import { jsx } from "react/jsx-runtime";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { validateTidalLicense } from "../../base/index.js";
function MoreHoriz(props) {
  return /* @__PURE__ */ jsx(
    MoreHorizIcon,
    {
      "data-testid": "MoreHoriz",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "MoreHoriz",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
MoreHoriz.tidalIconMeta = {
  categories: "common,navigation",
  name: "MoreHoriz"
};
validateTidalLicense();
export {
  MoreHoriz
};
//# sourceMappingURL=MoreHoriz.js.map
